import React from "react";
import Layouts from "../../Layouts";

import image from "../../../Assests/images/MahatmaGandhi_1.png";
import Krishnaswamy from "../../../Assests/About/Sri krishnaswamy iyer .png";
import Mahatma from "../../../Assests/About/Mahatma Gandhi.jpeg";
import SwamiVivekananda from "../../../Assests/About/Swami Vivekananda.jpeg";
import SubramaniaBharathi from "../../../Assests/About/Bharathiyar.jpeg";
import Chandrasekharendra from "../../../Assests/About/Chandrasekharendra .jpeg";
import BalasubramaniIyer from "../../../Assests/About/Balasubramani.png";
import border from "../../../Assests/images/BorderDesign.png";

const About = () => {
  return (
    <Layouts>
      <div className="min-h-screen bg-[#FAF8F3] text-gray-800">

        {/* =====================================================
            HERO
        ====================================================== */}
        <section className="relative w-full overflow-hidden">
          <img
            src={image}
            alt="The Venkataramana Ayurveda Dispensary"
            className="w-full h-auto object-cover"
          />

          <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent pointer-events-none" />
        </section>

        {/* =====================================================
            INTRO / FOUNDING HEADER
        ====================================================== */}
        <section className="relative bg-[#FFF1C7] border-b border-[#e8d69d]">

          <div className="max-w-7xl mx-auto px-5 sm:px-4 lg:px-8 py-4 md:py-8 text-center">

            <span className="inline-block mb-2 text-xs sm:text-sm font-semibold tracking-[0.35em] uppercase text-[#8B6B35]">
              A Heritage of Healing
            </span>

            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-serif font-bold tracking-wide text-[#5C3A21]">
              THE VENKATARAMANA
              <br className="sm:hidden" /> AYURVEDA DISPENSARY
            </h1>

            <p className="mt-2 text-sm sm:text-base md:text-lg font-semibold tracking-[0.3em] text-gray-700">
              EST. 1905
            </p>

            <img
              src={border}
              alt="Decorative border"
              className="mx-auto mt-3 w-40 sm:w-52 md:w-64 opacity-80"
            />
          </div>
        </section>

        {/* =====================================================
            FOUNDING STORY
        ====================================================== */}
        <section className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-16 md:py-24">

          <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">

            {/* IMAGE */}
            <div className="lg:col-span-5 order-1">

              <div className="relative max-w-md mx-auto lg:mx-0">

                {/* Decorative background */}
                <div className="absolute -top-5 -left-5 w-full h-full rounded-[2rem] border border-[#D6B66A]" />

                <div className="relative rounded-[2rem] overflow-hidden bg-white shadow-2xl border border-white">

                  <img
                    src={Krishnaswamy}
                    alt="Sri V. Krishnaswamy Iyer"
                    className="w-full aspect-[4/5] object-cover rounded-[2rem] transition-transform duration-700 hover:scale-[1.03]"
                  />
                </div>

                {/* Year badge */}
                <div className="absolute -bottom-6 -right-4 sm:right-6 bg-[#5C3A21] text-white rounded-2xl px-6 py-4 shadow-xl">
                  <p className="text-[10px] tracking-[0.25em] uppercase text-[#E9CE8A]">
                    Founded
                  </p>
                  <p className="text-2xl font-serif font-bold">
                    1905
                  </p>
                </div>

              </div>
            </div>

            {/* CONTENT */}
            <div className="lg:col-span-7 order-2">
              <div className="max-w-3xl">
                <span className="text-sm font-semibold tracking-[0.25em] uppercase text-[#A17A36]">
                  The Founder
                </span>

                <h2 className="mt-3 text-3xl sm:text-4xl md:text-5xl font-serif font-bold text-[#4E321F] leading-tight">
                  Sri V. Krishnaswamy Iyer
                </h2>

                <div className="mt-5 flex items-center gap-3">
                  <div className="w-14 h-[3px] bg-[#C79A45]" />
                  <div className="w-2 h-2 rounded-full bg-[#C79A45]" />
                </div>

                <div className="mt-8 space-y-6 text-gray-700">

                  <p className="text-base sm:text-lg leading-8 text-justify">
                    The Venkataramana Ayurveda Dispensary was founded in 1905
                    at Mylapore, Chennai, by{" "}
                    <strong className="text-[#5C3A21]">
                      Sri V. Krishnaswamy Iyer (1863–1911)
                    </strong>
                    , a distinguished jurist, educationist, philanthropist,
                    national thinker of Madras Presidency and founder of
                    Indian Bank.
                  </p>

                  <p className="text-base sm:text-lg leading-8 text-justify">
                    At a time when Western medicine dominated colonial
                    healthcare, Sri V. Krishnaswamy Iyer envisioned the revival
                    of Ayurveda as a scientific, ethical, and socially relevant
                    medical system.
                  </p>

                  <p className="text-base sm:text-lg leading-8 text-justify">
                    His mission was not merely to preserve ancient knowledge,
                    but to institutionalize Ayurveda so that it could serve
                    society through structured education, disciplined practice,
                    and compassionate public service.
                  </p>
                  <p className="text-base sm:text-lg leading-8 text-justify">
                   The establishment of the Venkataramana Ayurveda College and Dispensary marked a historic milestone in South Indian medical history. It became one of the earliest organized institutions to integrate classical Ayurvedic principles with public healthcare, ensuring access to treatment for all sections of society, especially the underserved.  
                  </p>

                </div>

              </div>
            </div>

          </div>
        </section>

        {/* =====================================================
            GREAT MINDS HEADER
        ====================================================== */}
        <section className="bg-[#FFF1C7] border-y border-[#e8d69d]">

          <div className="max-w-7xl mx-auto px-5 sm:px-4 lg:px-8 py-4 md:py-8 text-center">

            <span className="text-xs sm:text-sm font-semibold tracking-[0.35em] uppercase text-[#8B6B35]">
              A Remarkable Legacy
            </span>

            <h2 className="mt-3 text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-[#5C3A21]">
              A LEGACY INTERTWINED
              <br className="sm:hidden" /> WITH GREAT MINDS
            </h2>

            <img
              src={border}
              alt="Decorative border"
              className="mx-auto mt-3 w-40 sm:w-52 md:w-64 opacity-80"
            />

          </div>
        </section>

        {/* =====================================================
            PEOPLE SECTIONS
        ====================================================== */}
        <section className="max-w-7xl mx-auto px-5 sm:px-4 lg:px-8 py-4 md:py-8">

          <div className="space-y-20 md:space-y-28">

            {/* =================================================
                GANDHI
            ================================================= */}
            <PersonSection

              name="Mahatma Gandhi"
              image={Mahatma}
              imageAlt="Mahatma Gandhi"
              imageLeft={true}
              text={
                <>
                  In 1915, Mahatma Gandhi visited The Venkataramana Ayurveda
                  College and Dispensary and deeply admired Sri V. Krishnaswamy
                  Iyer’s contributions to the Swadeshi Movement and the revival
                  of Indian medicine.
                  <br />
                  <br />
                  In recognition of his remarkable service to the nation and
                  Ayurveda, Gandhi wrote a letter in which he honoured Sri V.
                  Krishnaswamy Iyer with the distinguished title{" "}
                  <strong className="text-[#5C3A21]">
                    “MAHAPURUSHA.”
                  </strong>
                </>
              }
            />

            {/* =================================================
                VIVEKANANDA
            ================================================= */}
            <PersonSection

              name="Swami Vivekananda"
              image={SwamiVivekananda}
              imageAlt="Swami Vivekananda"
              imageLeft={false}
              text={
                <>
                  After meeting and engaging with Swami Vivekananda, V.
                  Krishnaswamy Iyer developed a deep admiration for his profound
                  understanding of Hindu philosophy.
                  <br />
                  <br />
                  Recognizing his vision, he funded Vivekananda's historic
                  journey to Chicago in 1893, where his iconic speech continues
                  to be remembered and revered to this day.
                </>
              }
            />

            {/* =================================================
                BHARATHI
            ================================================= */}
            <PersonSection

              name="Subramania Bharathi"
              image={SubramaniaBharathi}
              imageAlt="Subramania Bharathi"
              imageLeft={true}
              text={
                <>
                  At his residence “ASHRAMA,” V. Krishnaswamy Iyer hosted many
                  eminent visitors, including Subramania Bharathi, who was
                  brought there by the noted publisher G. A. Natesan.
                  <br />
                  <br />
                  Initially, Krishnaswamy Iyer held a critical view of Bharathi
                  due to his radical writings and had not met him personally.
                  Without a formal introduction, Bharathi was simply requested
                  to sing.
                  <br />
                  <br />
                  As he began, Iyer was deeply moved, and by the second song,
                  he was brought to tears by its beauty. This moment transformed
                  his perception, and he became a great admirer of Bharathi. He
                  later supported and funded the first publication of Bharathi’s
                  songs.
                </>
              }
            />

            {/* =================================================
                CHANDRASEKHARENDRA
            ================================================= */}
            <PersonSection

              name="Chandrasekharendra Saraswati"
              image={Chandrasekharendra}
              imageAlt="Chandrasekharendra Saraswati"
              imageLeft={false}
              text={
                <>
                  Sri V. Krishnaswamy Iyer held deep respect for Hindu mutts and
                  religious institutions. When Chandrasekharendra Saraswati
                  became the pontiff of the Kanchi Mutt at a very young age,
                  Iyer was concerned about potential mismanagement and external
                  influence.
                  <br />
                  <br />
                  To safeguard the institution, he successfully advocated
                  before the High Court for the administration of the mutt
                  under the Court of Wards until the pontiff reached maturity.
                  <br />
                  <br />
                  In later years, when asked about the most dharmic person he
                  had encountered, Chandrasekharendra Saraswati remarked that
                  while he had met many wealthy individuals and many who followed
                  dharma, V. Krishnaswamy Iyer was unique in embodying both
                  wealth and unwavering commitment to dharma.
                </>
              }
            />

          </div>
        </section>

        {/* =====================================================
            HONOURS HEADER
        ====================================================== */}
        <section className="bg-[#FFF1C7] border-y border-[#e8d69d]">

          <div className="max-w-7xl mx-auto px-5 sm:px-4 lg:px-8 py-4 md:py-8 text-center">

            <span className="text-xs sm:text-sm font-semibold tracking-[0.35em] uppercase text-[#8B6B35]">
              Recognition
            </span>

            <h2 className="mt-3 text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-[#5C3A21]">
              HONOURS & RECOGNITION
            </h2>

            <img
              src={border}
              alt="Decorative border"
              className="mx-auto mt-3 w-40 sm:w-52 md:w-64 opacity-80"
            />

          </div>
        </section>

        {/* =====================================================
            HONOURS CARD
        ====================================================== */}
        {/* =====================================================
    HONOURS CARD
===================================================== */}
        <section
          className="
    w-full
    max-w-6xl
    mx-auto
    px-4
    xs:px-5
    sm:px-8
    lg:px-12
    py-12
    sm:py-16
    md:py-20
    lg:py-24
  "
        >
          <div
            className="
      relative
      w-full
      grid
      grid-cols-1
      lg:grid-cols-2
      bg-white
      rounded-2xl
      sm:rounded-3xl
      overflow-hidden
      shadow-lg
      sm:shadow-xl
      border
      border-[#eee5d4]
    "
          >

            {/* =================================================
        IMAGE
    ================================================== */}
            <div
              className="
        relative
        w-full
        bg-[#F3EFE7]
        flex
        items-center
        justify-center
        px-5
        py-8
        xs:px-6
        sm:px-10
        sm:py-12
        md:px-12
        md:py-14
        lg:p-12
        xl:p-14
      "
            >

              {/* Decorative frame */}
              <div
                className="
          absolute
          inset-4
          xs:inset-5
          sm:inset-7
          md:inset-8
          lg:inset-10
          border
          border-[#D7C08A]
          rounded-xl
          sm:rounded-2xl
          pointer-events-none
        "
              />

              {/* Decorative corners */}
              <div
                className="
          absolute
          top-5
          left-5
          sm:top-8
          sm:left-8
          w-6
          h-6
          sm:w-8
          sm:h-8
          border-t-2
          border-l-2
          border-[#B18A43]
        "
              />

              <div
                className="
          absolute
          top-5
          right-5
          sm:top-8
          sm:right-8
          w-6
          h-6
          sm:w-8
          sm:h-8
          border-t-2
          border-r-2
          border-[#B18A43]
        "
              />

              <div
                className="
          absolute
          bottom-5
          left-5
          sm:bottom-8
          sm:left-8
          w-6
          h-6
          sm:w-8
          sm:h-8
          border-b-2
          border-l-2
          border-[#B18A43]
        "
              />

              <div
                className="
          absolute
          bottom-5
          right-5
          sm:bottom-8
          sm:right-8
          w-6
          h-6
          sm:w-8
          sm:h-8
          border-b-2
          border-r-2
          border-[#B18A43]
        "
              />

              {/* Image wrapper */}
              <div className="relative z-10 w-full flex justify-center">

                <img
                  src={BalasubramaniIyer}
                  alt="K. Balasubramani Iyer receiving the Padma Bhushan"
                  className="
            block
            w-auto
            max-w-full
            h-auto
            max-h-[380px]
            xs:max-h-[420px]
            sm:max-h-[480px]
            md:max-h-[520px]
            lg:max-h-[560px]
            xl:max-h-[600px]
            object-contain
            rounded-lg
            transition-transform
            duration-700
            hover:scale-[1.03]
          "
                />

              </div>
            </div>


            {/* =================================================
        CONTENT
    ================================================== */}
            <div
              className="
        relative
        w-full
        flex
        flex-col
        justify-center
        px-6
        py-8
        xs:px-7
        sm:px-10
        sm:py-12
        md:px-12
        md:py-14
        lg:px-12
        lg:py-16
        xl:px-16
        xl:py-20
      "
            >

              {/* Background text */}
              <div
                className="
          hidden
          sm:block
          absolute
          top-5
          right-6
          md:top-8
          md:right-8
          lg:top-10
          lg:right-10
          text-[70px]
          md:text-[90px]
          lg:text-[110px]
          xl:text-[130px]
          font-serif
          font-bold
          text-[#F6F0E2]
          leading-none
          select-none
          pointer-events-none
        "
              >
                1965
              </div>


              <div className="relative z-10 w-full">

                {/* Award type */}
                <span
                  className="
            block
            text-[10px]
            xs:text-xs
            sm:text-sm
            font-semibold
            tracking-[0.18em]
            xs:tracking-[0.22em]
            sm:tracking-[0.3em]
            uppercase
            text-[#A17A36]
          "
                >
                  Padma Bhushan
                </span>


                {/* Person name */}
                <h2
                  className="
            mt-2
            sm:mt-3
            text-2xl
            xs:text-3xl
            sm:text-4xl
            md:text-[2.6rem]
            lg:text-4xl
            xl:text-5xl
            font-serif
            font-bold
            text-[#4E321F]
            leading-[1.15]
            break-words
          "
                >
                  K. Balasubramani Iyer
                </h2>


                {/* Decorative line */}
                <div className="mt-4 sm:mt-5 flex items-center gap-3">

                  <div className="w-10 xs:w-12 sm:w-14 h-[3px] bg-[#C79A45]" />

                  <div className="w-2 h-2 rounded-full bg-[#C79A45]" />

                </div>


                {/* Description */}
                <p
                  className="
            mt-5
            sm:mt-7
            text-sm
            xs:text-base
            sm:text-[17px]
            md:text-lg
            text-gray-700
            leading-7
            sm:leading-8
            text-left
            sm:text-justify
          "
                >
                  K. Balasubramani Iyer, MLC, son of Sri V. Krishnaswamy Iyer,
                  receives the{" "}
                  <strong className="text-[#5C3A21]">
                    Padma Bhushan
                  </strong>
                  , one of India’s highest civilian honours, from Dr. Sarvepalli
                  Radhakrishnan, President of India, on 26 January 1965.
                </p>


                {/* Date */}
                <div
                  className="
            mt-6
            sm:mt-8
            inline-flex
            max-w-full
            self-start
            items-center
            px-4
            sm:px-5
            py-2.5
            sm:py-3
            rounded-full
            bg-[#FFF3CE]
            border
            border-[#E5CC87]
          "
                >
                  <span
                    className="
              text-xs
              sm:text-sm
              font-bold
              text-[#6D4B24]
              whitespace-nowrap
            "
                  >
                    26 January 1965
                  </span>
                </div>

              </div>
            </div>

          </div>
        </section>
      </div>
    </Layouts>
  );
};


/* =============================================================
   REUSABLE PERSON SECTION
============================================================= */

const PersonSection = ({
  number,
  name,
  image,
  imageAlt,
  text,
  imageLeft = true,
}) => {
  return (
    <article className="w-full grid grid-cols-1 lg:grid-cols-12 items-center gap-10 sm:gap-12 md:gap-14 lg:gap-16">

      {/* =====================================================
          IMAGE
      ====================================================== */}
      <div
        className={`w-full lg:col-span-5 ${imageLeft ? "lg:order-1" : "lg:order-2"
          }`}
      >
        <div className="relative w-full max-w-[420px] mx-auto">

          {/* Decorative offset border */}
          <div
            className="
              absolute
              inset-0
              translate-x-2
              translate-y-2
              sm:translate-x-3
              sm:translate-y-3
              md:translate-x-4
              md:translate-y-4
              rounded-[1.5rem]
              sm:rounded-[1.75rem]
              md:rounded-[2rem]
              border
              border-[#D6B66A]
            "
          />

          {/* Image container */}
          <div
            className="
              relative
              w-full
              overflow-hidden
              rounded-[1.5rem]
              sm:rounded-[1.75rem]
              md:rounded-[2rem]
              bg-white
              border
              border-white
              shadow-lg
              sm:shadow-xl
            "
          >
            <img
              src={image}
              alt={imageAlt}
              className="
                block
                w-full
                h-auto
                max-h-[500px]
                sm:max-h-[550px]
                md:max-h-[600px]
                lg:max-h-[650px]
                object-contain
                transition-transform
                duration-700
                hover:scale-[1.03]
              "
            />
          </div>
        </div>
      </div>


      {/* =====================================================
          CONTENT
      ====================================================== */}
      <div
        className={`w-full lg:col-span-7 ${imageLeft ? "lg:order-2" : "lg:order-1"
          }`}
      >
        <div className="w-full max-w-3xl mx-auto lg:mx-0">

          {/* Small label */}
          <span
            className="
              block
              text-[10px]
              xs:text-xs
              sm:text-sm
              font-semibold
              tracking-[0.18em]
              xs:tracking-[0.22em]
              sm:tracking-[0.3em]
              uppercase
              text-[#A17A36]
            "
          >
            Influential Figure
          </span>


          {/* Person name */}
          <h2
            className="
              mt-2
              sm:mt-3
              text-2xl
              xs:text-3xl
              sm:text-4xl
              md:text-[2.6rem]
              lg:text-4xl
              xl:text-5xl
              font-serif
              font-bold
              text-[#4E321F]
              leading-[1.15]
              break-words
            "
          >
            {name}
          </h2>


          {/* Decorative line */}
          <div className="mt-4 sm:mt-5 flex items-center gap-3">
            <div className="w-10 xs:w-12 sm:w-16 h-[3px] bg-[#C79A45]" />

            <div className="w-2 h-2 rounded-full bg-[#C79A45]" />
          </div>


          {/* Content */}
          <div
            className=" mt-5 sm:mt-6 md:mt-7 text-sm xs:text-base sm:text-[17px] md:text-lg text-gray-700 leading-7 sm:leading-8 text-left sm:text-justify
            "
>
            {text}
          </div>

        </div>
      </div>

    </article>
  );
};

export default About;